/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type GetEvaluationNotFoundErrorCode = (typeof GetEvaluationNotFoundErrorCode)[keyof typeof GetEvaluationNotFoundErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEvaluationNotFoundErrorCode = {
  analysis_not_found: "analysis_not_found",
  analysis_case_not_found: "analysis_case_not_found",
  evaluation_not_found: "evaluation_not_found",
} as const;
